t = require('views/internal/teacup-with-helpers')('menu')

module.exports = ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.ul '.dynamic-pop-over-list'
    t.mustacheBlock 'menu_cards', ->
      t.li ->
        t.a { class: t.mustacheVar('js_class'), href: t.mustacheBlock('url', (-> t.mustacheVar('url'))) + t.mustacheBlockInverted('url', (-> '#')) }, ->
          t.text t.mustacheVar('name')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/menu.coffee